/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online hash generator. Compute SHA-1, SHA-256, SHA-384 and SHA-512 hashes of any text using your browser's Web Crypto API. Nothing is uploaded.`)
};

const es_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de hash en línea gratis. Calcula SHA-1, SHA-256, SHA-384 y SHA-512 de cualquier texto usando la Web Crypto API de tu navegador. Nada se sube.`)
};

const de_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Hash-Generator. Berechnen Sie SHA-1-, SHA-256-, SHA-384- und SHA-512-Hashes aus beliebigem Text mit der Web Crypto API Ihres Browsers. Nichts wird hochgeladen.`)
};

const nl_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online hash-generator. Bereken SHA-1, SHA-256, SHA-384 en SHA-512 hashes van elke tekst met behulp van de Web Crypto API van uw browser. Niets wordt geüpload.`)
};

const fr_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de hash en ligne gratuit. Calculez des hash SHA-1, SHA-256, SHA-384 et SHA-512 de n'importe quel texte en utilisant l'API Web Crypto de votre navigateur. Rien n'est téléchargé.`)
};

const it_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di hash online gratuito. Calcola hash SHA-1, SHA-256, SHA-384 e SHA-512 da qualsiasi testo utilizzando l'API Web Crypto del tuo browser. Nulla viene caricato.`)
};

const pt_br2_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de hash online gratuito. Calcule hashes SHA-1, SHA-256, SHA-384 e SHA-512 de qualquer texto usando a Web Crypto API do seu navegador. Nada é enviado.`)
};

const pt_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de hash online gratuito. Calcule hashes SHA-1, SHA-256, SHA-384 e SHA-512 de qualquer texto usando a Web Crypto API do seu navegador. Nada é enviado.`)
};

const ja_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインハッシュジェネレーター。ブラウザのWeb Crypto APIを使用して、任意のテキストのSHA-1、SHA-256、SHA-384、SHA-512ハッシュを計算します。何もアップロードされません。`)
};

const zh_hg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线哈希生成器。使用浏览器的 Web Crypto API 计算任意文本的 SHA-1、SHA-256、SHA-384 和 SHA-512 哈希值，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_meta_description", locale)
	if (locale === "en") return en_hg_meta_description(inputs)
	if (locale === "es") return es_hg_meta_description(inputs)
	if (locale === "de") return de_hg_meta_description(inputs)
	if (locale === "nl") return nl_hg_meta_description(inputs)
	if (locale === "fr") return fr_hg_meta_description(inputs)
	if (locale === "it") return it_hg_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_hg_meta_description(inputs)
	if (locale === "pt") return pt_hg_meta_description(inputs)
	if (locale === "ja") return ja_hg_meta_description(inputs)
	return zh_hg_meta_description(inputs)
};